import { render, staticRenderFns } from "./KayakListItem.vue?vue&type=template&id=dfbcddb4&scoped=true&"
import script from "./KayakListItem.vue?vue&type=script&lang=js&"
export * from "./KayakListItem.vue?vue&type=script&lang=js&"
import style0 from "./KayakListItem.vue?vue&type=style&index=0&id=dfbcddb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbcddb4",
  null
  
)

export default component.exports